import "../css/topad.css";

import React from "react";

const TopAd = () => {
  return (
    <div id="topad--div">
      <div className="topad--div-items">
        <p className="topad--div-item">
          {" "}
          <strong>Buy online, pick up in store</strong> —it's quick and
          convenient.{" "}
          <a style={{ color: "white" }} href="google.com">
            Pickup Options
          </a>
        </p>
      </div>
    </div>
  );
};

export default TopAd;
